import React from "react";

import { FormattedHTMLMessage } from "react-intl";
import { ProgramTheme } from "../../../../lib/types/types";
import { getSafe } from "../../../../lib/utils/getSafe";
import { StepCardComponent } from "../../StepCard/StepCard";

export const getAndFormatOrderedStepCards = (programTheme: ProgramTheme): React.ReactElement[] => {
  const stepComponents: (() => {
    title: React.ReactNode;
    icon: React.ReactNode;
    subtitle?: React.ReactNode;
  })[] = [];

  if (getSafe(() => programTheme.config.onfidoReportNames.includes("document"), false)) {
    stepComponents.push(() => ({
      title: (
        <FormattedHTMLMessage
          id="step.idCheckLoop.steps.idCheck.title"
          defaultMessage="Take a photo of your government ID"
        />
      ),
      subtitle: (
        <FormattedHTMLMessage
          id="step.idCheckLoop.steps.idCheck.subtitle"
          defaultMessage="A valid government-issued document such as a driver's license, state ID, passport, or residence permit."
        />
      ),
      icon: (
        <img
          className="sid-identity-check-steps__icon"
          alt=""
          src="https://assets-resources.sheerid.com/common/images/2018/icons/id-photo.svg"
        />
      ),
    }));
  }

  if (getSafe(() => programTheme.config.onfidoReportNames.includes("facial_similarity_motion"))) {
    stepComponents.push(() => ({
      title: (
        <FormattedHTMLMessage
          id="step.idCheckLoop.steps.selfie.title"
          defaultMessage="Take a selfie"
        />
      ),
      icon: (
        <img
          className="sid-identity-check-steps__icon"
          alt=""
          src="https://assets-resources.sheerid.com/common/images/2018/icons/selfie.svg"
        />
      ),
    }));
  }

  if (programTheme.docUploadEnabled) {
    stepComponents.push(() => ({
      title: (
        <FormattedHTMLMessage
          id="step.idCheckLoop.steps.docReview.title"
          defaultMessage="Upload proof of status"
        />
      ),
      icon: (
        <img
          className="sid-identity-check-steps__icon"
          alt=""
          src="https://assets-resources.sheerid.com/common/images/2018/icons/upload-proof.svg"
        />
      ),
    }));
  }

  return stepComponents.map((stepComponentFunction, i) => {
    const { title, subtitle, icon } = stepComponentFunction();
    return (
      <StepCardComponent
        title={title}
        subtitle={subtitle}
        icon={icon}
        isHighlighted={i === 0}
        key={title.toString()}
      />
    );
  });
};
